import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusBadgeVariant } from '@/components/shared/StatusBadge';

export type ConnectionStatusValue = 'CONNECTED' | 'DISCONNECTED' | 'ERROR' | 'UNKNOWN';

const STATUS_TO_VARIANT: Record<ConnectionStatusValue, StatusBadgeVariant> = {
  CONNECTED: 'success',
  DISCONNECTED: 'danger',
  ERROR: 'danger',
  UNKNOWN: 'warning',
};

export interface ConnectionStatusBadgeProps {
  status: string | null | undefined;
  className?: string;
}

export function ConnectionStatusBadge({
  status,
  className,
}: ConnectionStatusBadgeProps): JSX.Element | null {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  const normalizedStatus = status.toUpperCase() as ConnectionStatusValue;
  const variant =
    STATUS_TO_VARIANT[normalizedStatus] ?? ('warning' as StatusBadgeVariant);
  const label = t(`pages.scanners.statuses.${normalizedStatus.toLowerCase()}`, status);

  return (
    <StatusBadge variant={variant} className={className}>
      {label}
    </StatusBadge>
  );
}
